const mappings = {
  requested: {
    label: 'Solicitados',
    icon: 'far fa-fw fa-question-circle',
    sequence: 0,
  },
  revision: {
    label: 'Em vistoria',
    icon: 'fas fa-fw fa-glasses',
    sequence: 10,
  },
  correction: {
    label: 'Em correção',
    icon: 'fas fa-fw fa-edit',
    sequence: 20,
  },
  corrected: {
    label: 'Corrigidos',
    icon: 'fas fa-fw fa-edit',
    sequence: 30,
  },
  screening: {
    label: 'Triagem',
    icon: 'fas fa-fw fa-search',
    sequence: 40,
  },
  forwarded: {
    label: 'Encaminhados',
    icon: 'fas fa-fw fa-share',
    sequence: 50,
  },
  hospitalized: {
    label: 'Internados',
    icon: 'fas fa-fw fa-procedures',
    sequence: 60,
  },
  medicalRelease: {
    label: 'Alta médica',
    icon: 'fas fa-fw fa-notes-medical',
    sequence: 70,
  },
  pullout: {
    label: 'Em retirada',
    icon: 'fas fa-fw fa-dolly-flatbed',
    sequence: 80,
  },
  caught: {
    label: 'Saída',
    icon: 'fas fa-fw fa-sign-out-alt',
    sequence: 90,
  },
  done: {
    label: 'Concluídos',
    icon: 'fas fa-fw fa-check',
    sequence: 100,
  },
  death: {
    label: 'Falecidos',
    icon: 'fas fa-fw fa-skull-crossbones',
    sequence: 110,
  },
  rejected: {
    label: 'Rejeitados',
    icon: 'fas fa-fw fa-thumbs-down',
    sequence: 120,
  },
  canceled: {
    label: 'Cancelados',
    icon: 'fas fa-fw fa-ban',
    sequence: 130,
  },
  recordAdded: {
    label: 'Prontuário atualizado',
    icon: 'fas fa-fw fa-file-medical-alt',
    sequence: 140,
  },
  all: {
    label: 'Total de Atendimentos Clínicos',
    icon: 'fas fa-fw fa-stethoscope',
    sequence: 999,
  },
}

export default (status) => mappings[status] || { label: status, sequence: 998, icon: 'fas fa-fw fa-stethoscope' }
